module.exports = __webpack_public_path__ + "img/volunteer_halyk_logo.6060b29a.svg";